<template>
    <h5 class="result__title-game">
        {{ getTranslatedText(tab === 'okapiLottery' ? `loto 5/90` : 'Lotto Daily') }}
    </h5>
    <div class="result__canlendar-box">
        <Canlendar :buttonText="dateSelect !== '' ? formatDate(dateSelect) : 'Select date'" nameFunction="on-select-datepicker-result" />
        <ButtonCommon
            v-if="dateSelect"
            type="active"
            :isNoHover="true"
            :isLoadingWhiteColor="true"
            value="clear"
            @on-click-button-common="() => onClearFilter()"
        />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import Canlendar from '@/components/common/calendar/calendar.vue';
import ButtonCommon from '@/components/common/button/button.vue';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins],
    components: { Canlendar, ButtonCommon },
    props: {
        dateSelect: {
            type: String,
            default: '',
        },
        tab: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            date: '',
        };
    },
    methods: {
        onClearFilter() {
            this.$emit('on-clear-filter-date');
            EventBus.emit('on-clear-filter-date');
        },

        formatDate() {
            const dateParts = this.dateSelect.split('-');
            return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
        },
    },
};
</script>
